import api from './../helpers/api'
import { isEnabled, isWorkingOffline, queueSale } from '../helpers/offline'



class ProductService{

    get_products(){
        return api.get(`/get_products`).then(
            response => {
                return response.data
            }
        )
    }

    get_low_stock(){
        return api.get(`/low_stock`).then(
            response => { return response.data }
        )
    }

    update_minimum_stock(id, minimum_stock){
        return api.post(`/update_minimum_stock/${id}`, { minimum_stock }).then(
            response => { return response.data }
        )
    }

    get_product(id){
        return api.get(`/get_product/${id}`, );
    }

    //show product for sale

    show_for_sale(id){
        return api.post(`/show_for_sale/${id}`,{},);
    }

    create_product(product) {

        return api.post(`/add_product`,product).then(
            response => {
                return response.data
            }
        );
    }

    edit_product(id, product){
        return api.post(`/update_product/${id}`,product).then(
            response => {
                return response.data
            }
        );
    }

    removeProduct(id){
        return api.post(`/delete/${id}`,);
    }

    change_quantity(user_id,id,quantity,purchase){
        return api.post( `/change_quantity/${id}`,{
            user_id:user_id,
            quantity:quantity.quantity,
            name:purchase.name,
            amount:purchase.amount,
            pamount:purchase.pamount,
            wharehouse_id:quantity.wharehouse_id,
            description:quantity.description
        },);
    }

    get_quantity_changes(id){
        return api.get(`/get_changes/${id}`, );
    }

    //save cart
    save_cart(product_id,quantity,selling_price,id){
        return api.post(`/save_cart/${id}`,{
            product_id,quantity,selling_price

        }, );
    }

    get_cart_items(id){
        return api.post(`/get_cart/${id}`, );
    }

    get_cart(id){
        return api.post(`/cart/${id}`, );
    }

    deletep(id,product_id){
        return api.post(`/cart_delete/${id}`,{
            product_id
        }, );
    }

    clear_cart(id){
        return api.post(`/clear_cart/${id}`, );
    }

    //saving sales
    async save_sales(cart, client, balance, cart_total) {
        const body = {
            cart,
            id:                 client.id,
            amount:             client.amount,
            discount:           client.discount,
            credit_applied:     client.credit_applied || 0,
            balance,
            cart_total,
            payment_method_id:  client.payment_method_id || null,
            // Only set when the cashier is allowed to ring a sale for a past day.
            // Carried through the offline queue too, so a queued backdated sale
            // still lands on its intended date when it finally syncs.
            record_date:        client.record_date || undefined,
        };
        // Shape an offline "success" so the receipt still renders (with a local ref).
        const offlineResp = (ref) => ({
            data: { offline: true, data: { receipt_id: ref }, customer: client.names ? { names: client.names } : null },
        });
        // Already working offline → queue straight away.
        if (isEnabled() && isWorkingOffline()) {
            const ref = await queueSale(body);
            return offlineResp(ref);
        }
        try {
            return await api.post('/save_sales', body);
        } catch (err) {
            // Offline mode on and the request failed with no response (network) →
            // queue it for later instead of losing the sale.
            if (isEnabled() && !(err && err.response)) {
                const ref = await queueSale(body);
                return offlineResp(ref);
            }
            throw err;
        }
    }
    recent_sales(limit = 30) {
        return api.get('/recent_sales', { params: { limit } });
    }

    delete_item(){
        return api.get(`/del_items`,);
    }

    get_product_units(product_id) {
        return api.get(`/product_units/${product_id}`).then(r => r.data);
    }

    save_product_units(product_id, units) {
        return api.post(`/product_units/${product_id}`, { units }).then(r => r.data);
    }

    delete_product_unit(id) {
        return api.delete(`/product_unit/${id}`).then(r => r.data);
    }

    getProductImages(productId) {
        return api.get(`/product_images/${productId}`).then(r => r.data);
    }

    uploadProductImage(productId, formData) {
        return api.post(`/product_images/${productId}`, formData).then(r => r.data);
    }

    deleteProductImage(id) {
        return api.delete(`/product_image/${id}`).then(r => r.data);
    }

    // ── Bundle / Composite products ─────────────────────────────────────────
    getBundleItems(productId) {
        return api.get(`/bundle_items/${productId}`).then(r => r.data);
    }

    saveBundleItems(productId, items) {
        return api.post(`/bundle_items/${productId}`, { items }).then(r => r.data);
    }
}


export default new ProductService;